import { HttpServiceBase } from "./http-service-base";

export class ApplicationTagService extends HttpServiceBase {
    constructor(...rest) {
        super(...rest);
    }

    addTag(applicationId, tagName, group, formFieldName) {
        let data = {
            applicationId, tagName, group, formFieldName
        }

        return new Promise((resolve, reject) => {
            this.http.post(`v1/applicationTags`, data)
                .then(data => JSON.parse(data.response))
                .then(response => resolve(response))
                .catch(e => reject(e));
        });
    }

    removeTag(applicationId, tagName, group) {
        return new Promise((resolve, reject) => {
            let url = `v1/applicationTags?applicationId=${applicationId}&tagName=${tagName}`;
            if (group) {
                url += `&group=${group}`;
            }
            this.http.delete(url)
                .then(data => JSON.parse(data.response))
                .then(response => resolve(response))
                .catch(e => reject(e));
        });
    }
}
